import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zzjjddb",
  "use": "icon-zzjjddb-usage",
  "viewBox": "0 0 829.99 829.99",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 829.99 829.99\" id=\"icon-zzjjddb\"><title>在钻井进度对比</title><path d=\"M402.58,284.14H624.81V818.26H402.58Zm303.19-178H928V818.26H705.77Zm-384.15,332H99.39V818.26H321.62ZM271.88,759.34H149.14V497H271.88V759.34ZM98,876.71H927.53v59.38H98Z\" transform=\"translate(-98 -106.1)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol